import axios from "../utils/request";

export const getUserShare = () => axios.get("/distribution_img");

export const getUserRebateList = ({ page } = {}) =>
  axios.get("/fl", { params: { page } });

export const createWithdrawDetail = ({ money } = {}) =>
  axios.post("/tx", { money });

export const getOrders = ({ page = 1, status }) =>
  axios.get("/code", {
    params: {
      page,
      status
    }
  });

export const createOrder = ({
  id,
  tel,
  uid,
  shop,
  date,
  info,
  count,
  shape,
  // eslint-disable-next-line camelcase
  ticket_type
}) =>
  axios.post("/order", {
    tel,
    uid,
    info,
    shape,
    cid: id,
    ticket_type,
    use_date: date,
    totalNum: count,
    channel_id: shop
  });

export const updateOrder = ({ orderid, paychannel }) =>
  axios.post("/pay", { orderid, paychannel });

export const createRefund = ({ code }) =>
  axios.post("/refund", {
    code
  });

export const getUserOpenid = () => axios.get("/getopenid");

export const getUserAgencyStatus = ({ openid } = {}) =>
  axios.post("/gettravel", { openid });

export const createRechargeDetail = ({ money }) =>
  axios.post("/memberpay", { price: money });

export const getRechargeList = ({ page } = {}) =>
  axios.get("/payrecord", { params: { page } });

export const getConsumeList = ({ page } = {}) =>
  axios.get("/credit2", { params: { page } });

/* export const createUserDetail = ({ tel, password } = {}) =>
  axios.post('/user', {
    tel,
    password,
  }); */
export const createUserDetail = ({ tel, password } = {}) =>
  axios.post("/reg", {
    tel,
    password
  });
export const createUserlogin = ({ tel, password } = {}) =>
  axios.post("/login", {
    tel,
    password
  });

export const updateUserDetail = ({ tel, gameNickName } = {}) =>
  axios.put("/user", {
    tel,
    game_name: gameNickName
  });

export const getBalanceList = ({ page } = {}) =>
  axios.get("/credit2", { params: { page } });

export const getIntegralList = ({ page } = {}) =>
  axios.get("/credit1", { params: { page } });

export const getHoursList = ({ page } = {}) =>
  axios.get("/credit3", { params: { page } });

export const getParticipationList = ({ page }) =>
  axios.get("/match", { params: { page } });

export const getHoursRebateList = ({ page }) =>
  axios.get("/fanli", { params: { page } });

export const createBonusOrder = ({
  id,
  tel,
  uid,
  shop,
  date,
  info,
  count,
  shape,
  freeId
}) =>
  axios.post("/freecardo", {
    tel,
    uid,
    info,
    shape,
    cid: id,
    use_date: date,
    totalNum: count,
    channel_id: shop,
    free_id: freeId
  });

// 打开储物柜
// export const openTheLocker = ({ mac }) => axios.get(`/box:${mac}`)
export const openTheLocker = ({ mac }) =>
  axios.get("/box", { params: { mac } });
